import React, {Component} from "react";
import PropTypes from "prop-types";
import "bootstrap";
import {connect} from "react-redux";
import i18next from "i18next";
import { withRouter } from 'react-router';
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam.js";
import PopupWrapper from "../Common/PopupWrapper";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView, {GridRowEditMode} from "@mnjsplatform/components/lib/common/GridView/GridView";
import AddEmpToRVDRequest from "./AddEmpToRVDRequest";
import MnTooltipIcon from "../Common/MnTooltipIcon";
import PopupEditor from "../Common/PopupEditor";

class EditRVDRequest extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isDataReady: false,
      showMessage: false,
      messageText: "",
      messageTitle: "",
      showAddEmpoyeesForm: false,
      showEmployeeForm: false,
      rowKey: null,
      rowIndex: -1
    };
  }

  componentDidMount() {
    console.log("EditRVDRequest mount");
    this.onInit();
  }

  componentWillUnmount() {
    console.log("EditRVDRequest unmount");
  }

  onInit = async () => {
    try {
      //console.log(`this.props.rowKey: ${JSON.stringify(this.props.rowKey)} this.props.addMode: ${this.props.addMode}`);
      this.setState({isDataReady: false});

      await this.props.dispatch(this.props.dataItem.reset());
      await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
        refresh: true,
        withParams: false,
        newItem: true
      }));

      if (this.props.addMode) {
        await this.props.dispatch(this.props.dataItem.beginAdd());
      } else {
        await this.props.dispatch(this.props.dataItem.beginEdit(0));
        await this.props.dispatch(this.props.dataItem_PersList.initialize(this.props.rowKey, {
          refresh: true,
          withParams: false,
          newItem: true,
          withStyle: true
        }));
      }

      if (!this.props.dataItem.isError) {
        this.setState({isDataReady: true});
      }
    } catch (e) {
      await this.props.dispatch(e);
    }
  }

  onSave = async () => {
    await this.props.dispatch(this.props.dataItem.save());
    if (this.props.dataItem.isError) {
      this.setState({
        messageText: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
        messageTitle: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
        showMessage: !this.props.dataItem.isError
      });
    } else {
      if (this.props.addMode && this.props.onCreated) {
        const rowKey = this.props.dataItem.getRowKeyByIndex(0);
        this.props.onCreated(rowKey);
      }
      /*
            if (this.props.onRefresh)
              await this.props.onRefresh();
      */
      this.onClose();
    }
  }

  sendRequest = async (status) => {
    try {
      if (this.props.onSendRequest) {
        const rowKey = this.props.dataItem.getRowKeyByIndex(0);
        await this.props.onSendRequest(rowKey, status, true);
      }
      this.onClose();
    } catch (e) {
      console.error(e);
      await this.props.dispatch(this.props.dataItem_PersList.refresh());
    }
  }

  onMessageClose = () => {
    this.onClose();
  }

  renderParams = (h) => {
    return (
        <div className="row">
          <div className="col-md-12">
            {h.fs.map(fld => {
              return (<React.Fragment key={fld.fieldInfo.Name}>
                <div className="row">
                  <div className="col-md-3 text-md-right field-title">
                    {h.lbl(fld.Name)}
                  </div>
                  <div className="col-md-9">
                    {h.ed(fld.Name)}
                  </div>
                </div>
                <hr/>
              </React.Fragment>)
            })}
            {h.row._ErrDesc &&
                <div className="row">
                  <div className="col-md-3 text-md-right field-title text-danger">
                    {i18next.t("Errors")}
                  </div>
                  <div className="col-md-9 text-danger">
                    {h.row._ErrDesc}
                  </div>
                </div>
            }
          </div>
        </div>)
  }

  addEmployees = (e) => {
    e.preventDefault();
    this.setState({showAddEmpoyeesForm: true});
  }

  gridRowStyleProvider = (rowIndex, row) => {
    let style = {cursor: "pointer"};
    if (row._IsError) {
      return {
        ...style,
        color: "#bd2130"
      };
    }
    return style;
  }

  gridCellStyleProvider = (dataItem, rowIndex, fieldInfo) => {
    if (fieldInfo?.Name === "PartWorkMax")
      return ({textDecoration: 'underline'})
    else if (fieldInfo?.Name === "PartWorkFact" || fieldInfo?.Name === "PartWorkNight") {
      return ({fontWeight: 'bold'})
    }
  }

  renderRowsGridCellEx = (cellParams) => {
    if (cellParams.fieldInfo.Name === "_IsError") {
      //let tooltipText = DrawAttribute.cellTooltipProvider(cellParams.dataItem, cellParams.rowIndex, cellParams.fieldInfo);
      let tooltipText = cellParams.row._ErrDesc;
      return (
          <>
            {!tooltipText && cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex)}
            <MnTooltipIcon text={tooltipText} iconClass="fa fa-info-circle ml-2 gridcell-tooltip"/>
          </>
      );
    }
    return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
  }

  onClose = () => {
    if (this.props.onClose)
      this.props.onClose();
  }

  onCellClick = (row, fieldInfo, e) => {
    if (fieldInfo.Name !== '') {
      const rowKey = this.props.dataItem_PersList.getRowKey(row);
      const rowIndex = this.props.dataItem_PersList.getRowIndex2(row);
      this.setState({showEmployeeForm: true, rowKey: rowKey, rowIndex: rowIndex});
    }
  }

  cancel = async () => {
    await this.props.dispatch(this.props.dataItem_PersList.cancelEdit());
    this.setState({showEmployeeForm: false, rowKey: null, rowIndex: -1});
  }

  save = async () => {
    await this.props.dispatch(this.props.dataItem_PersList.save(this.state.rowIndex));
    if (this.props.dataItem_PersList.isError) {
      this.setState({
        messageText: this.props.dataItem_PersList.isError ? i18next.t("Error") : i18next.t("Success"),
        messageTitle: this.props.dataItem_PersList.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
        showMessage: !this.props.dataItem_PersList.isError
      });
    } else
      this.setState({showEmployeeForm: false, rowKey: null, rowIndex: -1});
  }

  renderEmployeeInfo = (h, status) => {
    return (
        <>
          <div className="row">
            <div className="col-md-12">
              {h.fs.map(fld => {
                let params = null;
                let control = {};
                if (fld.fieldInfo.Name === 'PartWorkMax') {
                  params = {readOnly: (status !== 'Prepare')};
                  control = h.ed(fld.Name, params);
                } else {
                  control = h.ed(fld.Name);
                }
                return (<React.Fragment key={fld.fieldInfo.Name}>
                  <div className="row">
                    <div className="col-md-3 text-md-right field-title">
                      {h.lbl(fld.Name)}
                    </div>
                    <div className="col-md-9">
                      {control}
                    </div>
                  </div>
                  <hr/>
                </React.Fragment>)
              })}
            </div>
          </div>
        </>
    )
  }

  onEndEditField = async (rowIndex, fieldDescriptor, forceApplyParams) => {
    //console.log(`this.props.addMode: [${this.props.addMode}] fieldDescriptor.fieldInfo.Name: [${fieldDescriptor.fieldInfo.Name}]`);
    if (!this.props.addMode/* && fieldDescriptor.fieldInfo.Name === 'IsEDocPers'*/) {
      await this.props.dispatch(this.props.dataItem.save(rowIndex));
    }
  }

  render() {
    if (!this.state.isDataReady)
      return null;

    const isCanLiftStatus = this.props.dataItem.getField(0, '_IsCanLiftStatus') === 1;
    const status = this.props.dataItem.getField(0, 'ReqStatusId');
    const readOnly = this.props.dataItem.getField(0, '_IsCanEdit') === 0 || status === 'Approve';
    let captionSave = i18next.t('Save');

    let upStatusCmdTitle, downStatusCmdTitle;
    if (status === 'Prepare') {
      upStatusCmdTitle = i18next.t("RVD_CreateOrder");
      captionSave = i18next.t("Save_Request_Draft");
    } else if (status === 'Facting') {
      //upStatusCmdTitle = i18next.t("Ввод факта завершен");
      upStatusCmdTitle = i18next.t("RVD_ApproveRequest");
      downStatusCmdTitle = i18next.t("RVD_DisbandOrder");
    } else if (status === 'Approve') {
      downStatusCmdTitle = i18next.t("RVD_RevokeApprovement");
    }

    const renderButtons = () => {
      return (<div className="modal-footer text-right">
        {/*{!this.props.addMode && !readOnly &&
        <button type="button" className="btn btn-regular -goescape ml1ex" data-dismiss="modal"
                onClick={this.addEmployees}>{i18next.t("ScheduleChangeRequest_AddEmployees")}</button>
        }*/}
        {
            isCanLiftStatus &&
            <button type="button" disabled={!this.state.isDataReady} className="btn btn-regular -goahead  ml1ex"
                    data-dismiss="modal" onClick={() => this.sendRequest(status)}>{upStatusCmdTitle}</button>
        }
        {!readOnly &&
            <button type="button" disabled={!this.state.isDataReady}
                    className="btn btn-regular -goahead  ml1ex" data-dismiss="modal"
                    onClick={this.onSave}>{captionSave}</button>
        }
        <button type="button" className="btn btn-regular ml1ex" data-dismiss="modal"
                onClick={this.onClose}>{i18next.t("Close")}</button>
      </div>)
    }
    return (
        <PopupWrapper popupVisible={true} title={i18next.t("Edit_RVD_Request_1")}
                      instructionId="EditRVDRequest"
                      renderButtons={renderButtons} onClose={this.props.onClose}>
          <div>
            {!this.state.isDataReady ?
                i18next.t('LoadingLabel')
                : <React.Fragment>
                  <MessageBox visible={this.state.showMessage}
                              title={this.state.messageTitle}
                              messageText={this.state.messageText}
                              onClose={this.onMessageClose}/>
                  <PlaceholderWrapper placeholderId="EditRVDRequest_10" showHeaderTitle={false} canCollapse={false}
                                      showSplitterLine={false}
                                      title={i18next.t("Edit_RVD_Request_2")}>
                    <ComplexParam dataItem={this.props.dataItem}
                                  showSearchBar={false} showApplyButton={false} autoApplyParams={false}
                                  readOnly={readOnly}
                                  rootPath={this.props.dataItemPath} renderParams={this.renderParams}
                                  onEndEditField={this.onEndEditField}
                    />
                  </PlaceholderWrapper>
                  {!this.props.addMode &&
                      <PlaceholderWrapper placeholderId="EditRVDRequest_20" showHeaderTitle={true} canCollapse={false}
                                          showSplitterLine={false} title={i18next.t("Employees")}
                                          staticTitle={i18next.t("Edit_RVD_Request_3")}
                    >
                        {/*
                    <GridViewInlineEdit2 dataItem={this.props.dataItem_PersList} allowPagination={true}
                                         rowStyleProvider={this.gridRowStyleProvider}
                                         renderCellEx={this.renderRowsGridCellEx}
                                         renderRowParams={this.renderRowParams}
                                         addButtonText={i18next.t("ScheduleChangeRequest_AddEmployees")}
                                         renderAddForm={(props) => {
                                           return <AddEmpToRVDRequest rowKey={this.props.rowKey}
                                                                      afterSave={() => {props.dispatch(props.dataItem_PersList.refresh());}}
                                                                      onClose={() => {props.hideEditor(); props.refreshDataItem();}}
                                                                      {...props} />;
                                         }}/>
*/}
                        <GridView dataItem={this.props.dataItem_PersList} allowPagination={true} /*readOnly={readOnly}*/
                                  rowStyleProvider={this.gridRowStyleProvider}
                                  cellStyleProvider={this.gridCellStyleProvider}
                                  renderCellEx={this.renderRowsGridCellEx}
                                  addButtonText={i18next.t("ScheduleChangeRequest_AddEmployees")}
                                  readOnly={readOnly}
                                  onCellClick={this.onCellClick}
                                  afterDeleteRow={async () => {
                                    await this.props.dispatch(this.props.dataItem.refresh());
                                  }}
                                  renderEditForm={(params) => {
                                    const rowKey = params.dataItem.getRowKey(params.row);
                                    const rowIndex = params.dataItem.getRowIndex2(params.row);
                                    this.setState({showEmployeeForm: true, rowKey: rowKey, rowIndex: rowIndex});
                                  }}
                                  renderAddForm={(props) => {
                                    return <AddEmpToRVDRequest rowKey={this.props.rowKey}
                                                               afterSave={async () => {
                                                                 await this.props.dispatch(this.props.dataItem_PersList.refresh());
                                                                 await this.props.dispatch(this.props.dataItem.refresh());
                                                               }}
                                                               onClose={() => {
                                                                 props.hideEditor();
                                                                 props.refreshDataItem();
                                                               }}
                                                               {...props} />;
                                  }}/>
                      </PlaceholderWrapper>
                  }
                  {this.state.showAddEmpoyeesForm &&
                      <AddEmpToRVDRequest rowKey={this.props.rowKey}
                                          afterSave={async () => {
                                            await this.props.dispatch(this.props.dataItem_PersList.refresh());
                                            await this.props.dispatch(this.props.dataItem.refresh());
                                          }}
                                          onClose={async () => {
                                            this.setState({showAddEmpoyeesForm: false});
                                          }}/>
                  }
                </React.Fragment>
            }
          </div>
          {this.state.showEmployeeForm &&
              <PopupEditor dataItem={this.props.dataItem_PersList} rowIndex={this.state.rowIndex}
                           title={this.props.dataItem_PersList.getField(this.state.rowIndex, 'PersonName')}
                           instructionId="EditRVDRequest_Person"
                           staticTitle={i18next.t("Edit_RVD_Request_4")}
                           visible={this.state.showEmployeeForm}
                           onParamRender={(h) => this.renderEmployeeInfo(h, status)}
                           readOnly={status === 'Approve'}
                           overrideVisibilityEdit={
                             Object.assign({_IsError: false, _ErrDesc: false}, (status === 'Prepare' ? {
                               PartWorkFact: false,
                               PartWorkNight: false
                             } : {}))}
                           onCancel={this.cancel} onSave={this.save}/>
          }
        </PopupWrapper>
    )
  }
}

EditRVDRequest.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dataItem: PropTypes.object,
  dataItem_Params: PropTypes.object,
  dataItem_PersList: PropTypes.object,
  onCreated: PropTypes.func,
  onSendRequest: PropTypes.func,
  onClose: PropTypes.func,
  onRefresh: PropTypes.func,
  rowKey: PropTypes.object,
  addMode: PropTypes.bool
};

EditRVDRequest.defaultProps = {
};

function mapStateToProps(state, ownProps) {
  return {
    dataItem_PersList: state.rvdState.WorkHolReqPers_POx_ListPers
  }
}

export default withRouter(connect(mapStateToProps)(EditRVDRequest));